

export function convertUrlQueryString(queryString: string){
    const urlParams = new URLSearchParams(queryString);
    return urlParams;
}